import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { currentYear, appName } from '../../helpers';

function Footer() {
  return (
    <footer className="footer">
      <Container fluid>
        <Row>
          <Col md={12} className="text-center text-md-start">
            © {currentYear} <span className="fw-semibold">{appName}</span>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
